module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-cover-4-b28a12c97c8b0978984443126cee299b.webp";